import { type ComponentProps } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { ProductDetailsButton } from '../ProductDetailsButton';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsChangeLocationButton = (props: Props) => {
  const { hasNoSelectedLocation } = props;

  const { formatMessage } = useIntl();

  // ─────────────────────────────────────────────────────────────────────

  return (
    <ProductDetailsButton
      accessibilityLabel={
        hasNoSelectedLocation
          ? formatMessage(messages.titleNoLocation)
          : formatMessage(messages.title)
      }
      {...props}
    >
      {hasNoSelectedLocation ? (
        <FormattedMessage {...messages.titleNoLocation} />
      ) : (
        <FormattedMessage {...messages.title} />
      )}
    </ProductDetailsButton>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Change location to order',
    description: 'Product Details | Change location to order button | Title',
  },
  titleNoLocation: {
    defaultMessage: 'Select location to order',
    description: 'Product Details | Select location to order button | Title',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<
  ComponentProps<typeof ProductDetailsButton>,
  'style' | 'children'
> & {
  hasNoSelectedLocation: boolean;
};
